import '../global.js';
import * as Helper from './Helpers';
import gsap from 'gsap';
import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';
import Accordion from './Accordion.js';

class TeamsFilters {

	static instance = null;

	static create(options) {
		if (TeamsFilters.instance === null) {
			TeamsFilters.instance = new TeamsFilters(options);
		} else {
			// Update container reference if instance already exists (e.g., on back navigation)
			TeamsFilters.instance.container = options.container || TeamsFilters.instance.defaultOptions.container;
			TeamsFilters.instance.options.container = TeamsFilters.instance.container;
			// Re-initialize to bind events to the new container
			TeamsFilters.instance.init();
		}
		return TeamsFilters.instance;
	}

	static destroy() {
		if (TeamsFilters.instance) {
			TeamsFilters.instance.beforeDestroy();
			TeamsFilters.instance = null;
		}
	}

	get defaultOptions() {
		return {
			container: document,
		};
	}

	constructor(options) {
		this.options = Object.assign({}, this.defaultOptions, options);
		this.container = this.options.container;
		this.isEnabled = true;
		this.simpleBar;
		this.isSimpleBar = false;
		this.applied = false;
		this.accordion = Accordion;
		this.mm = gsap.matchMedia();
		this.init();
		this.previousSearch = '';
	}

	init() {
		// Clean up any existing event handlers before re-initializing
		this.unbindEventHandlers();
		
		this.Filters();
		this.filterCount();
		setTimeout(() => {
			this.searchAutocomplete();
		}, 200);
		this.initTransition();
		this.createAccordion();
	}

	unbindEventHandlers() {
		// Unbind filter-wrap event handlers from document (delegated there for mobile support)
		$(document).off('change', '.filter-wrap :checkbox');
		$(document).off('click', '#reset-filters');
		$(document).off('click', '.filter-wrap #reset-filters-mobile');
		$(document).off('submit', '.filter-wrap form.search');
		$(document).off('keyup', '.filter-wrap #search');
		$(document).off('click', '.filter-wrap .reset-field');
		// These remain on the container
		if (this.container) {
			$(this.container).off('click', '.load-more-members');
		}
	}

	createAccordion() {
		this.accordion.create({
			speed: 0.5,
			element: '[data-accordion]',
			container: this.options.container

		});
	}

	destroyAccodion() {
		this.accordion.destroy();
	}

	initTransition() {
		// add transitioned data to already card
		$(this.container).find('.row-grid .col').addClass('fade-in');
	}

	updateURL(expertise, locations, sectors, firms) {
		const params = new URLSearchParams(location.search);

		if (expertise.length) {
			params.set('expertise', expertise.join(','));
		} else {
			params.delete('expertise');
		}

		if (locations.length) {
			params.set('location', locations.join(','));
		} else {
			params.delete('location');
		}

		if (sectors.length) {
			params.set('sector', sectors.join(','));
		} else {
			params.delete('sector');
		}

		if (firms && firms.length) {
			params.set('firm', firms.join(','));
		} else {
			params.delete('firm');
		}

		const newURL = `${location.pathname}?${params.toString()}`;
		history.pushState({}, '', newURL);
		window.barba.history.add(newURL, 'team');
	}

	Filters() {
		// Use event delegation on $(document) for .filter-wrap events because on mobile
		// FilterSwitch moves .filter-wrap to document.body (outside this.container),
		// so delegating from this.container would miss those events.
		$(document).on('change', '.filter-wrap :checkbox', (e) => {
			let value = $(e.target).val();

			if (value === 'all') {
				$(e.target).closest('ul').find('li input').prop('checked', false);
				$(e.target).prop('checked', true);
			} else {
				$(e.target).closest('ul').find('.filter-all').prop('checked', false);
				if (
					!$(e.target)
						.closest('ul')
						.find('li input:not(.filter-all)')
						.is(':checked')
				) {
					$(e.target).closest('ul').find('.filter-all').prop('checked', true);
				}
			}

			this.getResults(this.getFilters());
			this.filterCount();
		});

		$(document).on('click', '#reset-filters', () => {
			this.resetFilters();
			this.filterCount();
			this.getResults(this.getFilters());
		});

		$(document).on('click', '.filter-wrap #reset-filters-mobile', () => {
			$('.filter-wrap #search').val('')
			setTimeout(() => {
				this.resetFilters();
				this.filterCount();
				this.getResults(this.getFilters());
			}, 0);
		});

		$('body').on(
			'click',
			'.ui-menu-item-wrapper',
			(e) => {
				this.applied = true;
                this.resetFilters();
                this.filterCount();
				this.previousSearch = $(e.target).text();
				this.getResults(this.getFilters());
			}
		);

		$(document).on(
			'submit',
			'.filter-wrap form.search',
			(e) => {
				e.preventDefault();
				this.applied = true;
                this.resetFilters();
                this.filterCount();
				this.previousSearch = $(e.target).find('input').val();
				this.getResults(this.getFilters());
			}
		);

		$(this.container).on('click', '.load-more-members', (e) => {
			let slug = $(e.target).data('slug');
			let page = $(e.target).data('page');
			let scrollPosition = this.getScrollPosition();
			$(e.target)
				.html(`<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="16px" height="16px" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid">
                <circle cx="12" cy="12" fill="none" stroke="#ffffff" stroke-width="2" r="8" stroke-dasharray="18.84955592153876 8.283185307179586">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 12 12;360 12 12" keyTimes="0;1"/>
                </circle>
            </svg>`);

			setTimeout(() => {
				this.loadMore(
					this.getFilters(),
					slug,
					parseInt(page) + 1,
					scrollPosition,
				);
			}, 200);
		});

		$(document).on('keyup', '.filter-wrap #search', (e) => {
			if (!$('.filter-wrap #search').val() && this.applied) {
				this.previousSearch = '';
				this.getResults(this.getFilters());
				this.applied = false;
			}
			if ($('.filter-wrap #search').val()) {
				$('.filter-wrap form.search').addClass('filled');
			} else {
				$('.filter-wrap form.search').removeClass('filled');
			}
		});

		$(document).on('click', '.filter-wrap .reset-field', (e) => {
			$('.filter-wrap #search').val('');
			$('.filter-wrap form.search').removeClass('filled');
			if (this.applied) {
				this.previousSearch = '';
				this.getResults(this.getFilters());
				this.applied = false;
			}
		});
	}

	// Fetch checked filters, search field and nonce
	getFilters() {
		let locations = [];
		let sectors = [];
		let expertise = [];
		let firms = [];
		let blocked_locations = [];

		$('#location-filter input:checked').each((index, element) => {
			locations.push($(element).val());
		});

		$('#sector-filter input:checked').each((index, element) => {
			sectors.push($(element).val());
		});

		$('#expertise-filter input:checked').each((index, element) => {
			expertise.push($(element).val());
		});

		$('#firm-filter input:checked').each((index, element) => {
			firms.push($(element).val());
		});

		blocked_locations = $('#blocked_locations');
		blocked_locations = blocked_locations.length && JSON.parse(blocked_locations.text()) || [];

		let search = this.previousSearch;
		let nonce = $('#member-filters-nonce').val();

		return {locations, sectors, expertise, firms, search, nonce, blocked_locations};
	}

	// Ajax call
	getResults({locations, sectors, expertise, firms, search, nonce, blocked_locations}) {
		$('#smooth-wrapper').after('<div class="loading"></div>');
		this.destroyAccodion();
		let pageId = $('.section-team-list').data('page-id');

		setTimeout(() => {
			$.ajax({
				type: 'post',
				dataType: 'json',
				url: wp_ajax.ajaxurl,
				data: {
					action: 'team_member_filters',
					nonce,
					locations,
					sectors,
					expertise,
					firms,
					search,
					blocked_locations,
					pageId,
				},
				success: (result) => {
					let html =
						result.html !== '\n'
							? result.html
							: '<div class="no-result">No results</div>';
					if (result.html) {
						$(this.container).find('.section-portfolio .accordion').html(html);
						Helper.OpenCloseNew();
						Helper.HoverClassOnParent();
						$('.loading').remove();
					}

					this.updateURL(expertise, locations, sectors, firms);
					this.createAccordion();


					const appended = $(this.container).find('.row-grid .col:not(.fade-in)');
					const parent = appended.parent();

					let invert = 1;
					let duration = 1;
					let position = '-=0.5';

					if(window.innerWidth < 1200){
						invert = 0;
						duration = 0.1;
						position = '-=0.1';
					}

					gsap.set(appended, {alpha: 0});
					gsap.set(parent.parent(), {height: '100%'});

					setTimeout(() => {
						gsap
							.timeline({
								onStart: () => {
									if (!appended.hasClass('fade-in')) {
										appended.addClass('fade-in');
									}
								},
							})
							.to(appended, {y: 50, alpha: 0, duration: duration, delay: 0.2})
							.to(
								appended,
								{
									y: 0,
									alpha: 1,
									duration: 1,
									ease: 'power4.out',
									stagger: 0.1 * invert,
								},
								position
							);
					}, 0);


					this.mm.add('(max-width: 991px)', () => {
						setTimeout(() => {
							window.scrollTo(0, $(this.container).find('.section-team-list').offset().top - document.querySelector('.header').offsetHeight);
						}, 500);
					})

					this.mm.add('(min-width: 992px)', () => {
						setTimeout(() => {
							window.scroller.scrollTo(this.options.container.querySelector('.section-team-list'), {
								duration: 100,
								offset: document.querySelector('.header').offsetHeight * -1,
							});
						}, 100);
					})
				},
				error: (result) => {
					console.log(JSON.stringify(result));
				},
			});
		}, 200);
	}

	loadMore = (
		{locations, sectors, expertise, search, nonce},
		slug,
		page,
		scrollPosition,
	) => {
		$.ajax({
			type: 'post',
			dataType: 'json',
			url: wp_ajax.ajaxurl,
			data: {
				action: 'load_more_team_members',
				nonce,
				locations,
				sectors,
				expertise,
				search,
				slug,
				page,
			},
			success: (result) => {
				setTimeout(() => {
					const parent = $('.row-' + slug);
					parent.append(result.html);
					if (result.is_last) {
						$(`[data-slug='${slug}']`).hide();
					}
					$(`[data-slug='${slug}']`).html('Dive deeper');
					$(`[data-slug='${slug}']`).data('page', page);

					const appended = $(this.container).find('.row-grid .col:not(.fade-in)');
					gsap.set(appended, {alpha: 0});
					gsap.set(parent.parent(), {height: '100%'});
					const invert = 1;

					// Set back scroll position to current position
					gsap.to(window, {
						scrollTo: {
							y: scrollPosition,
						},
						duration: 0,
						ease: 'power4.inOut',
					});

					setTimeout(() => {
						gsap
							.timeline({
								onComplete: () => {
									if (!appended.hasClass('fade-in')) {
										appended.addClass('fade-in');
									}
								},
							})
							.to(appended, {y: 50, alpha: 0, duration: 1, delay: 0.2})
							.to(
								appended,
								{
									y: 0,
									alpha: 1,
									duration: 1,
									ease: 'power4.out',
									stagger: 0.1 * invert,
								},
								'-=0.5'
							);
					}, 0);
				}, 0);
			},
			error: (result) => {
				console.log(JSON.stringify(result));
			},
		});
	};

	filterCount = () => {
		let dropdowns = ['location', 'expertise', 'sector', 'firm'];

		dropdowns.forEach((dropdown) => {
			// Use global selectors since .filter-wrap may be detached from container on mobile
			let activeFilters = $(`#${dropdown}-filter input:checked`);
			let activeFiltersNumber = activeFilters.length;
			let selected = [];

			activeFilters.each((index, element) => {
				selected.push($(element).val());
			});

			if (selected.includes('all') || selected.length === 0) {
				activeFiltersNumber -= 1;
			}

			if (activeFiltersNumber > 0)
				$(`#${dropdown}-filter .filter-count`).html(`(${activeFiltersNumber})`);
			else $(`#${dropdown}-filter .filter-count`).html('');
		});

		let number = $('.filter-wrap input:checked:not(.filter-all)').length;

		if (number) {
			$('.filter-opener .filter-count').html(`(${number})`);
			if (window.innerWidth > 768) {
				$('#reset-filters').fadeIn();
			}
		} else {
			$('#reset-filters').fadeOut();
			$('.filter-opener .filter-count').html('');
		}
	};

	// Reset all filters
	resetFilters = () => {
		$('.filter-wrap input:checked').prop('checked', false);
		$('.filter-wrap input.filter-all').prop('checked', true);
		$('.filter-wrap #firm-filter input[value="lsip"]').prop('checked', true);
	};

	// Search autocomplete
	searchAutocomplete = () => {
		// Destroy existing autocomplete if it exists
		if (this.searchContainer) {
			$(this.searchContainer).autocomplete('destroy');
		}
		
		// Use global selector since .filter-wrap may be detached from container on mobile
		this.searchContainer = $('[data-filter-wrap-team] #search')[0];
		const filterInnerSearch = $('[data-filter-wrap-team] .inner .search')[0];
		if (this.searchContainer && typeof window.teamsAutocomplete !== 'undefined') {
			$(this.searchContainer).autocomplete({
				source: window.teamsAutocomplete,
				appendTo: filterInnerSearch,
				minLength: 1,
				autoFocus: false,
				open: (e) => {
					$(e.target).next('.ui-autocomplete').addClass('is-active');
					if (!this.isSimpleBar) {
						this.initSimplebar();
					}
				},
				select: (event, ui) => {
					$(event.target).removeClass('active');
					$(event.target).next('.ui-autocomplete').removeClass('is-active');
				},
				close: () => {
					this.destroySimpleBar();
				},
			});
		}
	};

	initSimplebar() {
		this.isSimpleBar = true;
		this.SimpleBar = new SimpleBar($('[data-filter-wrap-team] .ui-autocomplete')[0]);
	}

	destroySimpleBar() {
		if (this.isSimpleBar) {
			this.isSimpleBar = false;
			this.SimpleBar.unMount();
		}
	}

	enableAutocomplete = () => {
		$(this.searchContainer).autocomplete('enable');
	};

	getScrollPosition() {
		return window.pageYOffset || document.documentElement.scrollTop;
	}

	destroyAutoComplete() {
		if (this.searchContainer) {
			$(this.searchContainer).autocomplete('destroy');
		}
		if (typeof window.teamsAutocomplete !== 'undefined') {
			window.teamsAutocomplete = undefined;
		}
	}

	beforeDestroy() {
		// Unbind all event handlers from the container
		this.unbindEventHandlers();
		
		this.destroyAutoComplete();
		this.destroySimpleBar();
		this.destroyAccodion();
	}
}

export default TeamsFilters;
